import React from 'react'

import './topnav.css'

import ThemeMenu from '../thememenu/ThemeMenu'
import mobileLogo from '../../assets/images/logo_mobil.png'

const Topnav = ({ email, onSignOut, showMobileMenuButton, onToggleMobileMenu }) => {
    return (
        <div className='topnav'>
            {showMobileMenuButton ? (
                <button
                    type="button"
                    className="topnav__mobile-menu-btn"
                    aria-label="Otevřít menu"
                    onClick={() => onToggleMobileMenu && onToggleMobileMenu()}
                >
                    <i className='bx bx-menu'></i>
                </button>
            ) : null}
            <div className="topnav__right">
                <div className="topnav__right-item">
                    {showMobileMenuButton ? (
                        <div className="topnav__brand">
                            <img src={mobileLogo} alt="CRM Derator" className="topnav__brand-logo" />
                        </div>
                    ) : (
                        <div className="topnav__right-user">
                            <div className="topnav__right-user__name">
                                {email || 'Přihlášený uživatel'}
                            </div>
                        </div>
                    )}
                </div>
                {!showMobileMenuButton ? (
                    <div className="topnav__right-item">
                        <ThemeMenu email={email} />
                    </div>
                ) : null}
                <div className="topnav__right-item">
                    <button className="topnav__logout" type="button" onClick={() => onSignOut && onSignOut()}>
                        <i className='bx bx-log-out'></i>
                        Odhlásit
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Topnav
